// extracted by mini-css-extract-plugin
export default {"filter_controller":"FilterBasicController_filter_controller__etOU4"};